export class LevelObject {
    constructor(levelMap, _model, position) {
        this.levelMap = levelMap;
        this._model = _model;
        this.position = position;
        this._model.userData.levelObject = this;
    }
    static get type() {
        return null;
    }
    get type() {
        return this.constructor.type;
    }
    getProperties() {
        return {
            type: this.type,
        };
    }
    set model(newModel) {
        newModel.position.copy(this._model.position);
        newModel.rotation.copy(this._model.rotation);
        newModel.userData = this._model.userData;
        this._model.parent.add(newModel);
        this._model.parent.remove(this._model);
        this._model = newModel;
    }
    get model() {
        return this._model;
    }
    get position() {
        return this._model.position;
    }
    set position(position) {
        this._model.position.copy(position);
    }
    static findInObject3D(obj) {
        if (obj.userData.levelObject) {
            return obj.userData.levelObject;
        }
        if (obj.parent) {
            return LevelObject.findInObject3D(obj.parent);
        }
        return null;
    }
}
